// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../../../../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".tutorial-form--layout {\n  display: flex;\n  flex-direction: column;\n  gap: 12px; }\n  .tutorial-form--layout form {\n    display: flex;\n    flex-direction: column;\n    gap: 12px; }\n  .tutorial-form--layout .tutorial-form--actions {\n    display: grid;\n    grid-template-columns: repeat(2, 1fr);\n    gap: 10px;\n    align-items: center;\n    margin-top: 20px; }\n", ""]);
// Exports
module.exports = exports;
